export default "__VITE_ASSET__hGwGI3h2__"